import React, { Component } from 'react';
import { Button } from './ui/Button';
import { Shield, Lock, CreditCard, Check, Sparkles } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const tableRows = [{
    name: 'Protocolo Core: Vientre Plano 40+ (28 Días)',
    price: '$97.00'
  }, {
    name: 'Acelerador: Ritual de Infusiones Fisiológicas',
    price: '$29.97'
  }, {
    name: 'Sostenibilidad: Postres Fit Sin Culpa',
    price: '$39.97'
  }, {
    name: 'Logística: Smoothies Cero Inflamación',
    price: '$39.97'
  }];
  const benefits = ['El mapa exacto para resetear tu metabolismo en 28 días.', 'El secreto para bloquear la enzima COX-2 (causante de la hinchazón).', 'La libertad de comer chocolate y postres sin inflamar tu cuerpo.', 'Acceso inmediato y de por vida a todas las actualizaciones.'];
  return <section id="resumen-inversion" className="py-10 bg-cream relative overflow-hidden" data-id="element-388">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-389">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-390"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-sage/5 rounded-full blur-3xl" data-id="element-391"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-392">
        <div className="max-w-4xl mx-auto" data-id="element-393">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-394">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage mb-2" data-id="element-395">
              🌸 Resumen de tu Inversión en Salud
            </h2>
            <p className="text-lg text-gold font-semibold" data-id="element-396">
              (Especial Mes de la Mujer)
            </p>
          </div>

          {/* Value Table */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gold/20 mb-8" data-id="element-397">
            <table className="w-full" data-id="element-398">
              <thead data-id="element-399">
                <tr className="bg-sage text-cream" data-id="element-400">
                  <th className="text-left py-3 px-3 sm:px-5 font-serif font-bold text-sm sm:text-base" data-id="element-401">
                    Componente
                  </th>
                  <th className="text-right py-3 px-3 sm:px-5 font-serif font-bold text-sm sm:text-base whitespace-nowrap" data-id="element-402">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-403">
                {tableRows.map((row, idx) => <tr key={idx} className="border-b border-sage/10 last:border-0" data-id="element-404">
                    <td className="py-3 px-3 sm:px-5 text-sage font-medium text-sm sm:text-base" data-id="element-405">
                      {row.name}
                    </td>
                    <td className="py-3 px-3 sm:px-5 text-right text-sage/70 font-semibold text-sm sm:text-base whitespace-nowrap" data-id="element-406">
                      {row.price}
                    </td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-407">
                <tr className="border-t-2 border-sage/20 bg-cream/50" data-id="element-408">
                  <td className="py-3 px-3 sm:px-5 font-bold text-sage text-sm sm:text-base" data-id="element-409">
                    Valor Total:
                  </td>
                  <td className="py-3 px-3 sm:px-5 text-right font-bold text-sage line-through text-base sm:text-lg whitespace-nowrap" data-id="element-410">
                    $206.91
                  </td>
                </tr>
                <tr className="bg-gold/10" data-id="element-411">
                  <td className="py-3 px-3 sm:px-5 font-serif font-bold text-sage text-base sm:text-lg" data-id="element-412">
                    Precio Especial:
                  </td>
                  <td className="py-3 px-3 sm:px-5 text-right whitespace-nowrap" data-id="element-413">
                    <span className="text-2xl sm:text-4xl font-serif font-bold text-gold" data-id="element-414">
                      $7.49
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Why we do this */}
          <div className="bg-white rounded-3xl shadow-xl border border-sage/5 p-8 md:p-10 mb-8" data-id="element-415">
            <div className="flex items-center gap-3 mb-6" data-id="element-416">
              <Sparkles className="w-6 h-6 text-gold" data-id="element-417" />
              <h3 className="text-2xl font-serif font-bold text-sage" data-id="element-418">
                💡 Por qué hacemos esto:
              </h3>
            </div>
            <p className="text-sage/80 text-lg leading-relaxed mb-6" data-id="element-419">
              Queremos que tu transformación no dependa de tu presupuesto, sino
              de tu decisión. Por el Mes de la Mujer, hemos reducido el acceso
              al costo de un café premium.
            </p>

            <h4 className="text-xl font-serif font-bold text-sage mb-4" data-id="element-420">
              Lo que recibes por $7.49:
            </h4>
            <ul className="space-y-3 mb-8" data-id="element-421">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-422">
                  <div className="bg-gold/20 p-1.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-423">
                    <Check className="w-4 h-4 text-gold-dark" data-id="element-424" />
                  </div>
                  <span className="text-sage/80 font-medium" data-id="element-425">{benefit}</span>
                </li>)}
            </ul>

            {/* CTA */}
            <div className="text-center" data-id="element-426">
              <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" onClick={e => trackAddToCart(e)} className="inline-block w-full sm:w-auto mb-4" data-id="element-427">
                <Button size="xl" variant="primary" className="w-full sm:w-auto px-12 shadow-gold/30 text-base" data-id="element-428">
                  SÍ, QUIERO MI CUPO POR $7.49
                </Button>
              </a>
              <p className="text-sm text-sage/50 font-medium" data-id="element-429">
                Pagas una vez, lo tienes para siempre.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}